<template>
<main class="main-wrapper flex-grow-1">
<div class="d-flex align-items-center bg-white">
<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
		{{$t($t('3212'))}}
</div>                                                                                  
</div>
<div class="divider"></div>

<div class="container container--narrow">
	<form @submit.prevent="updateStore()" novalidate>
					<div class="pdt-50">
						<div class="t-subtitle5 font-m t-line-h-33">{{$t('3286')}}</div>
						<div class="t-body1 t-color-bodyGrayA t-line-h-24 mgt-4 font-r">
							{{$t('3287')}}
						</div>
						<div class="mgt-28">
										<label
														class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46  mdc-text-field--disabled"
														data-mdc-auto-init="MDCTextField" id="email">
														<span class="mdc-notched-outline">
																		<span class="mdc-notched-outline__leading"></span>
																		<span class="mdc-notched-outline__notch">
																			<span class="mdc-floating-label t-color-textfieldGuid font-r" id="my-label-id">
																				{{receivingDate}}
																			</span>
																		</span>
																		<span class="mdc-notched-outline__trailing"></span>
														</span>
														<input class="mdc-text-field__input t-color-disabledTextfieldText z-99" type="text" aria-labelledby="my-label-id" disabled>
														<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none"
																		tabindex="0" role="button">report_problem</i>
														</label>
														<div class="mdc-text-field-helper-line">
																		<div class="mdc-text-field-helper-text t-color-textDisabled t-helper font-r opacity-1 l-spacing36 t-line-h-20"
																						id="my-helper-id" >{{$t('3288')}}</div>
														</div>
														<div class="mgt-30">
																		<label
																						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field--disabled"
																						data-mdc-auto-init="MDCTextField" id="email">
																						<span class="mdc-notched-outline">
																										<span class="mdc-notched-outline__leading"></span>
																										<span class="mdc-notched-outline__notch">
																														<span class="mdc-floating-label t-body3" id="my-label-id">{{expirationDate}}</span>
																										</span>
																										<span class="mdc-notched-outline__trailing"></span>
																						</span>
																						<input class="mdc-text-field__input t-body3 font-r t-color-disabledTextfieldText z-99" type="text" aria-labelledby="my-label-id" value="20210602" disabled>
																						<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none" tabindex="0"
																										role="button">report_problem</i>
																		</label>
																		<div class="mdc-text-field-helper-line">
																						<div class="mdc-text-field-helper-text t-color-textDisabled t-helper font-r opacity-1 l-spacing36 t-line-h-20"
																										id="my-helper-id" aria-hidden="true">{{$t('3289')}}</div>
																		</div>
														</div>
														<div class="mgt-30">
															<label
																			class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
																			data-mdc-auto-init="MDCTextField"
																			:class="submitState && stockInvalidCheck ? 'mdc-text-field--invalid' : stock !==''?'textFieldVal':''"
																			id="stockEl">
																			<span class="mdc-notched-outline">
																				<span class="mdc-notched-outline__leading"></span>
																				<span class="mdc-notched-outline__notch">
																					<span class="mdc-floating-label t-body3" id="my-label-id">{{$t('3290')}}</span>
																				</span>
																				<span class="mdc-notched-outline__trailing"></span>
																			</span>
																			<input class="mdc-text-field__input t-body3 font-r" type="text"
																				v-model="stock"
																				v-validate="'required|min:0'"
																				ref="stocks"
																				id="stocks"
																				name="stocks"
																				min="0"
																				maxlength="40"
																				@keypress="checkInvalid">
																			<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none" tabindex="0"
																							role="button">report_problem</i>
															</label>
															<div class="mdc-text-field-helper-line">
																			<div class="mdc-text-field-helper-text t-helper font-r opacity-1 l-spacing36 t-line-h-20"
																							id="my-helper-id" aria-hidden="true" :class="submitState && stockInvalidCheck ? 't-color-mainBtn' : ' t-color-textfieldActive'" >{{submitState?$t('3291'):''}}</div>
															</div>
											</div>
						</div>
						<div class="divider mgt-28"></div>
						<div class="t-subtitle5 font-m t-line-h-33 mgt-28"> {{$t('3254')}}  </div>
						<div v-for="(checklist,index) in checkedList" :key="index">
						<div class="t-body1 t-color-headlineBlack t-line-h-22 l-spacing42 mgt-24 font-r ">
									{{++index}}. {{checklist.checkedListAnswer}}
						</div>
						<div class="d-flex">
										<div class="mdc-form-field mgr-24 mgt-14 choice">
											<div class="mdc-radio mdc--radio__custom   radio-button-color">
												<input class="mdc-radio__native-control" type="radio" id="radios-1" v-model="checklist.answer" :name="'answer'+index" value="true" :checked="checklist.answer == 'true'">
												<div class="mdc-radio__background">
																<div class="mdc-radio__outer-circle"></div>
																<div class="mdc-radio__inner-circle"></div>
												</div>
												<div class="mdc-radio__ripple"></div>
											</div>
											<label for="radios-1" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3274')}}</label>
										</div>
										<div class="mdc-form-field mgr-24  mgt-14 choice">
											<div class="mdc-radio mdc--radio__custom   radio-button-color">
															<input class="mdc-radio__native-control" type="radio" id="radios-2"  v-model="checklist.answer" :name="'answer'+index" value="false" :checked="checklist.answer == 'false'">
															<div class="mdc-radio__background">
																			<div class="mdc-radio__outer-circle"></div>
																			<div class="mdc-radio__inner-circle"></div>
															</div>
															<div class="mdc-radio__ripple"></div>
											</div>
											<label for="radios-2" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3275')}}</label>
										</div>
						</div>
						</div>
						<div class="divider mgt-28 mgb-28"></div>
						<div class="t-subtitle5 font-m t-line-h-33  ">
										{{$t('3295')}}
						</div>
						<div class="t-body1 t-color-bodyGrayA t-line-h-24  font-r mgt-4">
										{{$t('3296')}}
						</div>
						<label for="file" v-if="image == null || image.resourceUri==''">
					<input
						type="file"
						id="commentFileUpload"
						:accept="allowExt()"
						@change="uploadFile"
						class="d-none"
					/>
						<div @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" tabindex="0"
						 	class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column position-relative">
								<div><i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i></div>
								<div class="t-helper t-color-contentBlueMedium">{{ $t('3297') }}</div>
							</div>
						</label>
						<div
						   v-if="image && image.resourceUri"
										class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column position-relative">
										<input
											type="file"
											id="commentFileUpload"
											:accept="allowExt()"
											@change="uploadFile"
											class="d-none"
										/>
										<div><img :src="image.resourceUri" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" alt="" tabindex="0">
														<span class="remove-img remove-edm-image position-absolute t-color-white" @click="removeProductImage" @keypress="removeProductImage" tabindex="0"><i
																		class="material-icons t-body1">close</i></span>
										</div>
										<!-- <div class="t-helper t-color-contentBlueMedium">Add photo</div> -->
						</div>
		</div>
		<div class="mgt-50 pdb-34">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r font-m">{{$t('3298')}}</span>
						</button>
						<button class="mdc-button  t-color-secondaryBtnText b-radius4 mgr-8" @click="moveBack" @keypress="moveBack" tabindex="0">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r font-m">{{$t('3299')}}</span>
						</button>
		</div>
		</form>
</div>
</main>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import {MDCMenu} from '@material/menu';
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";
import storeApi from '@/api/storeMgtApi.js'
import httpService from "@/api/httpService.js";
import NoData from '../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
	components: {
		NoData,
		InfiniteLoading
	},

	data() {
		return {
			details: null,
			checkedList:[],
			picked:'',
			tabBar: null,
			stockTextField: null,
			receivingDate:null,
			expirationDate:null,
			stockReceivingDate:null,
			stockExpirationDate:null,
			stock:'',
			image: null,
			uploadTypeImg: true,
			submitState: false,
		}
	},

	mounted() {
	this.$showLoading();
		//  window.mdc.autoInit();
		this.$refs.stocks.focus()
		this.stockTextField = new MDCTextField(document.querySelector('#stockEl'))
		this.stockTextField.useNativeValidation = false
		this.stocks = '';
		this.stockTextField.value = this.stocks;

		if (document.querySelector('.mdc-tab-bar')) {
			this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'));
		}
		if (document.querySelectorAll(".content-trigger")) {
			var contentTrigger = Array.from(document.querySelectorAll(".content-trigger"));
			contentTrigger.forEach((item) => {
				item.addEventListener("click", function () {
					if ((this.firstChild.innerHTML) === 'keyboard_arrow_down') {
						this.firstChild.innerHTML = 'keyboard_arrow_up'
					} else {
						this.firstChild.innerHTML = 'keyboard_arrow_down'
					}
					this.parentNode.nextElementSibling.classList.toggle("d-none")

				});
			})
		}
		if(document.querySelectorAll('.toggle-menu')){
			const menuEls = Array.from(document.querySelectorAll('.toggle-menu'));

			menuEls.forEach((menuEl) => {
				// Initialize MDCSimpleMenu on each ".mdc-simple-menu"
				const menu = new MDCMenu(menuEl);
				// We wrapped menu and toggle into containers for easier selecting the toggles
				const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
				dropdownToggle.addEventListener('click', () => {
					menu.open = !menu.open;
				});
			});
		}

		let params = {
			goodsId: this.$route.params.goodsId
		}

		// get exam view information
		storeApi.storeView(params).then((response) => {
			this.details = response.data.data
			let checkedListAnswer = this.details?this.details.checkedList:''
			this.receivingDate=this.$moment(this.details.receivingDate).format('YYYYMMDD')
			this.expirationDate=this.$moment(this.details.expirationDate).format('YYYYMMDD')
			this.stockReceivingDate=this.details.receivingDate
			this.stockExpirationDate=this.details.expirationDate
			this.stock=this.details.stock
			this.image=this.details.image

			if(checkedListAnswer){
				for (let checkedListAns in checkedListAnswer) {
					for (let checkListQues of this.details.goods.checkList) {
						//console.log('checkedListAns',checkedListAnswer[checkedListAns])
						if (checkedListAnswer[checkedListAns].ordinal === checkListQues.ordinal) {
							Object.assign(checkedListAnswer[checkedListAns], {checkedListAnswer: checkListQues.checklistItem})
						}
					}
				}
			}
			this.checkedList=checkedListAnswer
			this.$hideLoading();
		}).catch(err => {
		  this.$hideLoading();
		});

		// this.setInputFilter(document.getElementById("stocks"), function(value) {
		//     return /^\d*$/.test(value); 
		// });
		this.$hideLoading();
	},
	
	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		// setInputFilter(textbox, inputFilter) {
		//     ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
		//         textbox.addEventListener(event, function() {
		//         if (inputFilter(this.value)) {
		//             this.oldValue = this.value;
		//             this.oldSelectionStart = this.selectionStart;
		//             this.oldSelectionEnd = this.selectionEnd;
		//         } else if (this.hasOwnProperty("oldValue")) {
		//             this.value = this.oldValue;
		//             this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
		//         } else {
		//             this.value = "";
		//         }
		//         });
		//     });
		// },

		stockInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('stock')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.stockTextField.valid === !returnValue ? '' : this.stockTextField.valid = !returnValue
			return returnValue
		},

		checkInvalid(){
			this.submitState=false
		},
		
		uploadFile(evt) {
			if (!evt.target.files[0]) return;
				this.$showLoading();
				storeApi
					.upload(evt.target.files[0])
					.then(response => {
					this.$hideLoading();
						this.image = response.data.data[0];
					})
					.catch(err => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},

		openFileUpload(allowImg,type) {
			this.uploadTypeImg = allowImg;
			this.type = type
			setTimeout(() => {
				document.getElementById("commentFileUpload").click();
			}, 0);
		},

		allowExt() {
			return this.type ? "image/jpeg,image/png" : "image/jpeg,image/png";
		},

		removeProductImage() {
			this.image=null
		},
		
		updateStore() {
			this.$validator.validateAll().then((resultValid) => {
		
			if(resultValid) {
				let params = {
					"id" : this.$route.params.goodsId,
					"checkedList" : this.checkedList,
					"stock" : this.stock,
					"receivingDate" : this.stockExpirationDate,
					"expirationDate" : this.stockReceivingDate,
					"image" : this.image,
					"auditor": this.details.auditor,
				}
				
				this.$showLoading();
				storeApi.storeUpdate(this.$route.params.goodsId,params).then((response)=>{
					this.$hideLoading();
					//console.log('response=>',response)
					this.$router.push({
						name: 'StoreView',
						params: this.$route.params.goodsId,
					})
				}).catch((error)=>{
					this.$hideLoading();
					console.log('error',error)
				});
			} else{
			   this.submitState=true
			   this.$hideLoading();
			   this.stockInvalidCheck() 
			}
		   })
		   this.$hideLoading();
		},
		moveBack(){
			this.$router.push({
				name: 'StoreView',
				params: {goodsId: this.$route.params.goodsId},
			})
		}
	}
}
</script>
<style scoped>
	
	.imagePlaceHolder{
		width: 104px;
		height: 104px;
	}

	.imageWrapper{
		/* max-height: 100px; */
		display: flex;
	}
	.imageWrapper img {
		/* object-fit:scale-down; */
	}
	.img-thumbnail{
		width: 104px;
	}
	.img-thumbnail img{
		border-radius: 4px;
		width: 104px;
		height: 104px;
		object-fit: cover;
	}
 
	
	.img-border{
		margin-bottom: -4px !important;
	}
	.closeIcon {
		top: -8px;
		right: -8px;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		background: var(--Iconinactive);
		display: flex;
		justify-content: center;
		align-items: center;
		border: 3px solid var(--DocumentWhite);
		color: var(--DocumentWhite);
		line-height: 0px;
	}
	html[dir="rtl"] .closeIcon {
		left: -8px;
	}
	.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
		border-color: var(--Textfeildactive) !important;
	}
</style>